module.exports = __webpack_public_path__ + "img/ad.184d977a.png";